const initialstate =  {
 
}

export { initialstate }


// WEBPACK FOOTER //
// ./src/redux/initialstate.js